import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import withDragDropContext from '../../utils/withDnDContext'
import EventsStore from '../../stores/EventsStore'
import ClientsStore from '../../stores/ClientsStore'
import AddressEquipment from '../../components/Clients/AddressEquipment'
import { Button, Dimmer, Form, Grid, Header, List, Loader } from 'semantic-ui-react'
import UsersStore from '../../stores/UsersStore'
import moment from 'moment'
import CalendarStore from '../../stores/CalendarStore'
import Scheduler from 'react-big-scheduler'
import LoadingWrapper from '../../components/LoadingWrapper'
import ModalError from '../../components/ModalError'
import 'react-big-scheduler/lib/css/style.css'

@withDragDropContext
@withRouter
@inject('eventsStore', 'clientsStore')
@observer
class EventsCreateScreen extends Component {
  static propTypes = {
    eventsStore: PropTypes.instanceOf(EventsStore),
    clientsStore: PropTypes.instanceOf(ClientsStore),
    match: PropTypes.object,
    history: PropTypes.object
  }

  state = {
    clientId: null,
    clientAddressId: null,
    clientAddress: null,
    clientAddressEquipmentId: null,
    equipment: null,
    userId: null,
    dateStart: moment().format('YYYY-MM-DD'),
    dateEnd: moment().format('YYYY-MM-DD'),
    timeStart: '07:00',
    timeEnd: '15:00'
  }

  constructor (props) {
    super(props)
    if (!props.match.params.clientId) {
      props.history.goBack()
    }
    this.usersStore = new UsersStore()
    this.calendarStore = new CalendarStore()
    this.state.clientId = parseInt(props.match.params.clientId)
    this.state.clientAddressId = parseInt(props.match.params.clientAddressId)
    this.state.clientAddressEquipmentId = parseInt(props.match.params.clientAddressEquipmentId)
    this.state.viewModel = this.calendarStore.schedulerData
  }

  componentDidMount () {
    const { clientsStore } = this.props
    const { clientId } = this.state
    clientsStore.loadOne(clientId).then(() => { this.updateEmployeeList() })
  }

  selectEmployee (userId) {
    this.setState({ userId })
  }

  updateEmployeeList () {
    const { clientsStore } = this.props
    const { clientAddressId, clientAddressEquipmentId } = this.state
    let clientAddress
    if (clientAddressId) {
      clientAddress = clientsStore.client.clients_addresses.find(clientAddress => clientAddress.id === clientAddressId)
      this.setState({ clientAddress })
      if (clientAddress && clientAddressEquipmentId) {
        const clientsAddressesEquipment = clientAddress.clients_addresses_equipments.find(clientAddressEquipment => clientAddressEquipment.id === clientAddressEquipmentId)
        this.usersStore.getUsersByEquipmentId(clientsAddressesEquipment.equipment_id).then(() => {
          const userIds = this.usersStore.users.map(user => user.id)
          this.calendarStore.loadWithUsers(userIds)
        })
      }
    }
  }

  handlerSelectAddressEquipment = (clientAddressId, clientAddressEquipmentId) => {
    const { clientId } = this.state
    const { history } = this.props
    const pathname = `/events/create/${clientId}/${clientAddressId}/${clientAddressEquipmentId}`
    history.push({ pathname })
    this.setState({ clientAddressId, clientAddressEquipmentId }, () => {
      this.updateEmployeeList()
    })
  }

  handleGoBack = () => {
    const { clientId } = this.state
    const { history } = this.props
    const pathname = `/events/create/${clientId}`
    history.push({ pathname })
    this.usersStore.clearList()
    this.setState({
      clientAddressId: null,
      clientAddress: null,
      clientAddressEquipmentId: null,
      equipment: null,
      userId: null,
      dateStart: moment().format('YYYY-MM-DD'),
      dateEnd: moment().format('YYYY-MM-DD'),
      timeStart: '07:00',
      timeEnd: '15:00'
    })
  }

  handleDateStartChange = (e, data) => {
    this.setState({ dateStart: data.value, dateEnd: data.value })
  }

  handleDateChange = (e, data) => {
    this.setState({ [data.name]: data.value })
  }

  prevClick = (schedulerData) => {
    schedulerData.prev()
    this.calendarStore.schedulerData = schedulerData
    this.calendarStore.load().then(() => {
      this.setState({ viewModel: this.calendarStore.schedulerData })
    })
  }

  nextClick = (schedulerData) => {
    schedulerData.next()
    this.calendarStore.schedulerData = schedulerData
    this.calendarStore.load().then(() => {
      this.setState({ viewModel: this.calendarStore.schedulerData })
    })
  }

  handleViewChange = (schedulerData, view) => {
    schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective)
    schedulerData.config.creatable = !view.isEventPerspective
    this.calendarStore.schedulerData = schedulerData
    this.calendarStore.load().then(() => {
      this.setState({ viewModel: this.calendarStore.schedulerData })
    })
  }

  handleSelectDate = () => {

  }

  handleConfirm = () => {
    const { eventsStore, history } = this.props
    const { clientId, clientAddressId, clientAddressEquipmentId, userId, dateStart, dateEnd, timeEnd, timeStart } = this.state
    const start = moment(`${dateStart} ${timeStart}`, 'YYYY-MM-DD HH:mm').utc()
    const end = moment(`${dateEnd} ${timeEnd}`, 'YYYY-MM-DD HH:mm').utc()
    eventsStore.createInspectionEvent(userId, clientId, clientAddressEquipmentId, start, end).then(() => {
      history.push(`/clients/view/${clientId}#${clientAddressId}`)
    }).catch()
  }

  render () {
    const { clientId, clientAddressId, clientAddressEquipmentId, userId, dateStart, dateEnd, timeEnd, timeStart, viewModel } = this.state
    const { eventsStore } = this.props
    const { client, isLoading } = this.props.clientsStore
    const { users } = this.usersStore
    if (isLoading) {
      return (
        <Dimmer page active={isLoading}>
          <Loader />
        </Dimmer>
      )
    }
    if (!clientAddressEquipmentId) {
      return (
        <>
          <Header as='h2'>Sélectionner un équipement</Header>
          <Grid columns='equal' padded='vertically'>
            {!!clientAddressId && <AddressEquipment clientId={clientId} clientAddress={client.clients_addresses.find(clientsAddress => clientsAddress.id === clientAddressId)} canEdit={false} canSelect handleSelect={this.handlerSelectAddressEquipment} />}
            {!clientAddressId && client.clients_addresses.map(clientsAddress => (
              <AddressEquipment key={clientsAddress.id} clientId={clientId} clientAddress={clientsAddress} canEdit={false} canSelect handleSelect={this.handlerSelectAddressEquipment} />
            ))}
          </Grid>
        </>
      )
    } else {
      return (
        <>
          <LoadingWrapper loading={eventsStore.isSaving} message='Sauvegarde en cours...' />
          <ModalError store={eventsStore} />
          <Header as='h2'>Création d'une inspection</Header>
          <Button onClick={this.handleGoBack}>Changer l'équipement</Button>
          <Grid columns='equal' padded='vertically'>
            {!!clientAddressId && <AddressEquipment clientId={clientId} clientAddress={client.clients_addresses.find(clientsAddress => clientsAddress.id === clientAddressId)} canEdit={false} clientAddressEquipementId={clientAddressEquipmentId} handleSelect={this.handlerSelectAddressEquipment} />}
            <Grid.Row>
              <Grid.Column width={8}>
                <Header as='h4'>Sélectionner un employé</Header>
                {this.usersStore.isLoading &&
                  <Dimmer active inverted>
                    <Loader>Chargement</Loader>
                  </Dimmer>}
                {users.length > 0 && (
                  <List selection divided relaxed='very' verticalAlign='middle'>{users.map(user => (
                    <List.Item key={user.id} active={user.id === userId} onClick={() => { this.selectEmployee(user.id) }}>
                      <List.Content>
                        <List.Header>{user.fullName}</List.Header>
                      </List.Content>
                    </List.Item>
                  ))}
                  </List>
                )}
              </Grid.Column>
              <Grid.Column width={8}>
                <Header as='h4'>Sélectionner une date</Header>
                <Form>
                  <Form.Group widths='equal'>
                    <Form.Input type='date' data-date-format='DD MMMM YYYY' label='Date de début' name='dateStart' value={dateStart} onChange={this.handleDateStartChange} />
                    <Form.Input type='time' label='Heure de début' name='timeStart' value={timeStart} onChange={this.handleDateChange} />
                  </Form.Group>
                  <Form.Group widths='equal'>
                    <Form.Input type='date' data-date-format='DD MMMM YYYY' label='Date de fin' name='dateEnd' value={dateEnd} onChange={this.handleDateChange} />
                    <Form.Input type='time' label='Heure de fin' name='timeEnd' value={timeEnd} onChange={this.handleDateChange} />
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <Scheduler
                  schedulerData={viewModel}
                  prevClick={this.prevClick}
                  nextClick={this.nextClick}
                  onSelectDate={this.handleSelectDate}
                  onViewChange={this.handleViewChange}
                  eventItemClick={this.eventClicked}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Button primary onClick={this.handleConfirm} disabled={!userId}>Créer l'inspection</Button>
        </>
      )
    }
  }
}

export default EventsCreateScreen
